var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 9.18709C12.7501 8.92759 12.7501 8.79784 12.7891 8.68234C12.9023 8.34634 13.2016 8.21659 13.5016 8.08009C13.8376 7.92634 14.0056 7.84984 14.1728 7.83634C14.3618 7.82134 14.5516 7.86184 14.7136 7.95259C14.9281 8.07259 15.0781 8.30209 15.2311 8.48809C15.9383 9.34759 16.2923 9.77734 16.4213 10.2506C16.5263 10.6331 16.5263 11.0336 16.4213 11.4153C16.2331 12.1068 15.6368 12.6858 15.1951 13.2228C14.9693 13.4966 14.8561 13.6338 14.7136 13.7141C14.5488 13.8055 14.3606 13.8459 14.1728 13.8303C14.0056 13.8168 13.8376 13.7403 13.5008 13.5866C13.2008 13.4501 12.9023 13.3203 12.7891 12.9843C12.7501 12.8688 12.7501 12.7391 12.7501 12.4803V9.18709ZM5.25005 9.18709C5.25005 8.86009 5.24105 8.56684 4.97705 8.33734C4.88105 8.25409 4.75355 8.19634 4.4993 8.08009C4.16255 7.92709 3.99455 7.84984 3.8273 7.83634C3.32705 7.79584 3.0578 8.13784 2.7698 8.48884C2.0618 9.34759 1.7078 9.77734 1.57805 10.2513C1.47366 10.6326 1.47366 11.0349 1.57805 11.4161C1.76705 12.1068 2.36405 12.6866 2.80505 13.2228C3.0833 13.5603 3.34955 13.8686 3.8273 13.8303C3.99455 13.8168 4.16255 13.7403 4.4993 13.5866C4.7543 13.4711 4.88105 13.4126 4.97705 13.3293C5.24105 13.0998 5.25005 12.8066 5.25005 12.4803V9.18709Z",
    stroke: "#3E3E3F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.20831V7.08331C15 4.18381 12.3135 1.83331 9 1.83331C5.6865 1.83331 3 4.18381 3 7.08331V8.20831M15 13.4583C15 16.8333 12 16.8333 9 16.8333",
    stroke: "#3E3E3F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_icon.5128006ea11788dfcf2b02e00f603dd7.svg";
export { ForwardRef as ReactComponent };